import { useTheme } from '@mui/material';
import { CompositeDecorator } from 'draft-js';

interface LinkProps {
	/** The editor's state */
	contentState: any;
	/** The link's key */
	entityKey: string;
	/** The children text component */
	children: React.ReactNode;
}

const linkStrategy = (contentBlock, callback, contentState) => {
	contentBlock.findEntityRanges(char => {
		const entityKey = char.getEntity();
		return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
	}, callback);
};

/** A custom link component used to display links in the HtmlEditor component */
const Link = ({ contentState, entityKey, children }: LinkProps) => {
	const theme = useTheme();
	const { url } = contentState.getEntity(entityKey).getData();
	return (
		<a
			style={{ background: 'inherit', color: theme.palette.secondary.main }}
			href={url}
			rel="noopener noreferrer"
			target="_blank"
			aria-label={url}
		>
			{children}
		</a>
	);
};

const editorDecorator = new CompositeDecorator([
	{
		strategy: linkStrategy,
		component: Link
	}
]);

export default editorDecorator;
